<template>
  <aside
    :class="[
      'sidebar bg-blue_primary border-r flex flex-col fixed h-screen overflow-y-auto overflow-x-hidden',
      collapsed ? 'w-20' : 'w-72',
    ]"
  >
    <!-- Logo: completo, o recortado al oso cuando está contraído -->
    <div class="h-[60px] mx-4 border-b border-white/50 flex justify-center shrink-0">
      <button
        type="button"
        :class="['logo-frame', { collapsed }]"
        aria-label="Go to dashboard"
        @click="goHome"
      >
        <img src="/kamvu/logox4.png" alt="Kamvu" />
      </button>
    </div>

    <div class="px-4 pt-6 flex-1">
      <NavMenuList :collapsed="collapsed" />
    </div>

    <!-- Contraer / expandir sidebar -->
    <div class="px-4 py-3 border-t border-white/20 shrink-0">
      <button
        type="button"
        :class="['collapse-btn', { 'justify-center': collapsed }]"
        :aria-label="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
        :aria-expanded="!collapsed"
        :title="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
        @click="toggleCollapsed"
      >
        <svg
          :class="['w-4 h-4 shrink-0 transition-transform duration-200', { 'rotate-180': collapsed }]"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M11 5l-5 5 5 5" />
          <path d="M16 5l-5 5 5 5" />
        </svg>
        <span v-if="!collapsed" class="truncate">Collapse</span>
      </button>
    </div>
  </aside>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import NavMenuList from "./NavMenuList.vue";

// Menú lateral fijo de escritorio. Se puede contraer a solo iconos.
export default {
  components: { NavMenuList },
  setup() {
    const store = useStore();
    const router = useRouter();

    const collapsed = computed(() => store.getters.sidebarCollapsed);
    const toggleCollapsed = () =>
      store.commit("setSidebarCollapsed", !collapsed.value);
    const goHome = () => router.push({ name: "dashboard" });

    return { collapsed, toggleCollapsed, goHome };
  },
};
</script>

<style scoped>
.sidebar {
  transition: width 0.25s ease;
}

/* El logo es una sola imagen (oso + texto); contraído se muestra solo el oso. */
.logo-frame {
  display: flex;
  align-items: center;
  margin: 6px 0;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  transition: max-width 0.25s ease;
}

/* Expandido: el logo completo se ajusta al ancho disponible */
.logo-frame img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 48px;
  object-fit: contain;
}

/* Contraído: alto fijo y ancho natural, recortado por el marco para mostrar solo el oso */
.logo-frame.collapsed {
  max-width: 43px;
}

.logo-frame.collapsed img {
  width: auto;
  height: 40px;
  max-height: none;
  max-width: none;
}

.collapse-btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.875rem;
  white-space: nowrap;
  transition: background-color 0.2s, color 0.2s;
}

.collapse-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.collapse-btn:focus-visible,
.logo-frame:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.7);
  outline-offset: -2px;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar,
  .logo-frame {
    transition: none;
  }
}
</style>
